import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@material-ui/core';

const UserProductBox = ({ product, button }) => {
    return (
        <Grid item xs={12} sm={6} md={3} style={{ marginBottom: '20px' }}>
            <Card variant="outlined" style={{ borderTop: "3px solid #EBBB5B", height: '100%' }}>
                <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                    <Box display="flex" justifyContent="center" mb={2}>
                        <img
                            src={product.imageUrl}
                            alt="Loading..."
                            height="75px"
                        />
                    </Box>

                    <Typography variant="h5" align="center" gutterBottom>
                        {product.name}
                    </Typography>

                    <p className="text-muted text-center" style={{ minHeight: "60px" }}>{product.details}</p>

                    <ul className="list-group list-group-unbordered mb-3">
                        <li className="list-group-item">
                            <b>{'Homepage'}</b>
                            <span className="float-right">
                                <a href={product.homePage} target="_blank">{product.companyName}</a>
                            </span>
                        </li>
                        <li className="list-group-item">
                            <b>{'Benötigte Likes'}</b>
                            <span className="float-right">{product.price}</span>
                        </li>
                        <li className="list-group-item">
                            <b>{'Verfügbarkeit'}</b>
                            <span className="float-right">
                                {product.quantity - product.blockedPieces} von {product.quantity}
                            </span>
                        </li>
                        <li className="list-group-item">
                            <b>{'Tage zum deserven'}</b>
                            <span className="float-right">
                                {product.timeperiode}
                                {/* {t('forms.options' + timeperiodeCurrency)} */}
                            </span>
                        </li>
                        <li className="list-group-item">
                            <b>Ablaufdatum</b>
                            <span className="float-right">
                                {new Date(product.timeperiodeTo).toLocaleDateString('de-DE')}
                            </span>
                        </li>
                    </ul>
                    {button}

                </CardContent>
            </Card>
        </Grid>
    );
};

export default UserProductBox;
